/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { consola } from "../consola.js";
export async function promptSdkVersion({
  sdkVersion,
  template
}) {
  if (sdkVersion == null) {
    // Default to the latest discovered version for the template
    return Object.keys(template.files).at(-1);
  }
  if (template.files[sdkVersion] == null) {
    consola.fail(`The ${template.label} template does not support a "${sdkVersion}" SDK version.`);
    sdkVersion = await consola.prompt(`Please choose which version of the OSDK you'd like to use for the ${template.label} template:`, {
      type: "select",
      options: Object.keys(template.files).reverse().map(sdkVersion => ({
        label: sdkVersion,
        value: sdkVersion
      }))
    });
  }
  return sdkVersion;
}